import { render, staticRenderFns } from "./HeaderMagazine.vue?vue&type=template&id=74e6bdd1&"
import script from "./HeaderMagazine.vue?vue&type=script&lang=js&"
export * from "./HeaderMagazine.vue?vue&type=script&lang=js&"
import style0 from "./HeaderMagazine.vue?vue&type=style&index=0&id=74e6bdd1&prod&lang=postcss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports